import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../assets/images/logo-light.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-menu fs-22"
}, null, -1);
const _hoisted_2 = {
  class: "ms-2 d-flex align-items-center"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "l"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "40",
  src: _imports_0
})], -1);
const _hoisted_4 = {
  class: "d-flex align-items-center justify-content-end"
};
const _hoisted_5 = {
  key: 2,
  class: "ms-1 d-none d-lg-inline-block"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-bell fs-22"
}, null, -1);
const _hoisted_7 = {
  class: "dropdown-head rounded-top dropdown-menu-lg"
};
const _hoisted_8 = {
  style: {
    "font-family": "'hkgrotesk', sans-serif"
  }
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "d-flex justify-content-center mb-3"
};
const _hoisted_12 = {
  class: "d-flex justify-content-center mb-3"
};
const _hoisted_13 = {
  class: "text-h6 text-center full-width m-auto text-muted my-5"
};
const _hoisted_14 = {
  class: "table table-hover"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "d-flex align-items-center border-warning"
};
const _hoisted_17 = {
  class: "flex-shrink-0 align-items-center"
};
const _hoisted_18 = ["alt", "src"];
const _hoisted_19 = {
  key: 1,
  class: "avatar-sm"
};
const _hoisted_20 = {
  class: "avatar-title rounded-circle text-primary bg-light"
};
const _hoisted_21 = {
  class: "flex-grow-1 ms-3"
};
const _hoisted_22 = {
  class: "fs-13 header-font"
};
const _hoisted_23 = {
  class: "d-flex justify-content-between"
};
const _hoisted_24 = {
  class: "text-muted mb-0 text-capitalize",
  style: {
    "font-size": "12px"
  }
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-link-external fs-20 ms-2"
}, null, -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-fullscreen fs-22"
}, null, -1);
const _hoisted_27 = {
  class: "pa-3",
  style: {
    "width": "100%"
  }
};
const _hoisted_28 = {
  class: "border-bottom pa-4"
};
const _hoisted_29 = {
  class: "d-flex justify-content-between align-self-center align-items-center"
};
const _hoisted_30 = {
  class: "text-start ms-xl-2 align-items-center",
  style: {
    "min-width": "200px"
  }
};
const _hoisted_31 = {
  class: "ms-1 d-block fw-medium"
};
const _hoisted_32 = {
  class: "ms-1 fs-12 d-block text-muted"
};
const _hoisted_33 = {
  class: "my-1"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-chart-areaspline text-muted fs-16 align-middle me-1"
}, null, -1);
const _hoisted_35 = {
  class: "align-middle"
};
const _hoisted_36 = {
  class: "my-1"
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-chart-timeline-variant text-muted fs-16 align-middle me-1"
}, null, -1);
const _hoisted_38 = {
  class: "align-middle"
};
const _hoisted_39 = {
  class: "my-1"
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-account-cog-outline text-muted fs-16 align-middle me-1"
}, null, -1);
const _hoisted_41 = {
  class: "align-middle"
};
const _hoisted_42 = {
  class: "my-1"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", {
  class: "bx bx-bell text-muted fs-16 align-middle me-1"
}, null, -1);
const _hoisted_44 = {
  class: "align-middle"
};
const _hoisted_45 = {
  class: ""
};
const _hoisted_46 = {
  class: "align-middle"
};
const _hoisted_47 = {
  "data-toggle": "fullscreen"
};
const _hoisted_48 = {
  class: "align-middle"
};
const _hoisted_49 = {
  class: ""
};
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-logout text-muted fs-16 align-middle me-1 my-1"
}, null, -1);
const _hoisted_51 = {
  class: "align-middle"
};
const _hoisted_52 = {
  class: "align-items-center flex-column text-center justify-content-center"
};
import i18n from '../i18n';
import { useStore } from 'vuex';
import usePlanPrice from '@/composable/plan-price';
import useAuth from '@/composable/auth';
import { formatNumber } from 'chart.js/helpers';
import { useRoute, useRouter } from 'vue-router';
import useNotifications from '@/composable/notifications';
import { customizeText } from '../helpers/formatter';
import { computed, onMounted, ref } from 'vue';
import useLayouts from '@/composable/layout';
// TODO make the default language comes from the local storage to sve old value

export default {
  __name: 'nav-bar',
  setup(__props) {
    const isDarkMood = ref(false);
    const {
      toggleSidebar,
      isCollapse
    } = useLayouts();
    const store = useStore();
    const getCurrentUser = computed(() => store.getters['auth/getCurrentUser']);
    const switchMode = newMode => {
      store.dispatch('changeMode', {
        mode: newMode
      });
    };
    function setLanguage(locale) {
      i18n.global.locale = locale;
      localStorage.setItem('lang', locale);
    }
    function initFullScreen() {
      document.body.classList.toggle('fullscreen-enable');
      if (!document.fullscreenElement && /* alternative standard method */
      !document.mozFullScreenElement && !document.webkitFullscreenElement) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
    function toggleDarkMode() {
      const currentTheme = document.documentElement.getAttribute('data-bs-theme');
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      isDarkMood.value = newTheme === 'dark';
      document.documentElement.setAttribute('data-bs-theme', newTheme);
      localStorage.removeItem('theme');
      localStorage.setItem('theme', newTheme);
      let htmlElement = document.querySelector('html');
      htmlElement.classList.remove('light', 'dark');
      htmlElement.classList.add(newTheme);
      switchMode({
        mode: newTheme
      }); // Dispatch the action with the new mode
    }
    const {
      hasUnreadMsg,
      handleReadMsg,
      handleDeleteAllNotify,
      fetchNotification,
      isNotifyLoading,
      notificationList,
      notifyUnreadCount
    } = useNotifications();
    const router = useRouter();
    const route = useRoute();
    const hasPermissions = computed(() => permission => {
      return store.getters['auth/hasPermission'](permission);
    });
    const {
      LogoutUser
    } = useAuth();
    const {
      subscriptionRemainingDays
    } = usePlanPrice();
    async function logout() {
      await LogoutUser();
    }
    async function handleReadMessages() {
      handleReadMsg();
    }
    async function handleDeleteAll() {
      handleDeleteAllNotify();
    }
    async function handleRedirection(path, id) {
      handleReadMsg(id);
      router.push(path);
    }
    const notificationDropdown = ref(null);
    async function goToNotificationPage() {
      await router.push('/profile/notifications');
      if (notificationDropdown?.value) {
        notificationDropdown.value.handleClose();
      }
    }
    async function handleClickNotifications() {
      fetchNotification({
        per_page: 5
      });
    }
    onMounted(() => {
      isDarkMood.value = localStorage.getItem('theme') === 'dark';
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_b_col = _resolveComponent("b-col");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_b_row = _resolveComponent("b-row");
      const _component_b_spinner = _resolveComponent("b-spinner");
      const _component_b_badge = _resolveComponent("b-badge");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      return _openBlock(), _createBlock(_component_b_row, {
        class: "align-items-center",
        "no-gutters": "",
        style: {
          "height": "100% !important"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          class: "d-flex align-items-center",
          cols: "6"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "notifyBtn d-none d-md-inline-block",
            round: "",
            text: "",
            variant: "ghost-secondary",
            onClick: _cache[0] || (_cache[0] = $event => _unref(toggleSidebar)(!_unref(isCollapse)))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
            class: "logo",
            to: "/dashboard"
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_b_col, {
          cols: "6"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [getCurrentUser.value?.delegatee?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            class: "p-1 me-1 d-none d-lg-inline-block",
            type: "warning"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegatee')) + " : " + _toDisplayString(getCurrentUser.value?.delegatee?.fullname?.split(' ')[0]), 1)]),
            _: 1
          })) : _createCommentVNode("", true), getCurrentUser.value?.delegator?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            class: "p-1 d-none d-lg-inline-block",
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegator')) + " : " + _toDisplayString(getCurrentUser.value?.delegator?.fullname?.split(' ')[0]), 1)]),
            _: 1
          })) : _createCommentVNode("", true), hasPermissions.value('subscription-list-request') ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tag, {
            type: _unref(subscriptionRemainingDays) > 4 ? 'info' : 'danger'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.subscription')) + ": " + _toDisplayString(_unref(subscriptionRemainingDays)) + " " + _toDisplayString(_ctx.$t('header.daysRemaining')), 1)]),
            _: 1
          }, 8, ["type"])])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
            ref_key: "notificationDropdown",
            ref: notificationDropdown,
            trigger: "click"
          }, {
            dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_b_row, {
              "align-v": "center",
              class: "m-2",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [_createVNode(_component_b_col, {
                class: "mx-1"
              }, {
                default: _withCtx(() => [_createElementVNode("h5", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t('notifications.notification')) + " ", 1), _unref(notifyUnreadCount) ? (_openBlock(), _createElementBlock("span", _hoisted_9, " ( " + _toDisplayString(_unref(formatNumber)(_unref(notifyUnreadCount))) + " ) ", 1)) : _createCommentVNode("", true)])]),
                _: 1
              }), _createVNode(_component_b_col, {
                class: "text-end"
              }, {
                default: _withCtx(() => [!_unref(isNotifyLoading) && _unref(notificationList)?.data?.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_tooltip, {
                  content: _ctx.$t('notifications.clearAll'),
                  class: "box-item",
                  effect: "light",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("i", {
                    class: "ri-delete-bin-line fs-18 gradient-text align-top me-3",
                    onClick: handleDeleteAll
                  })]),
                  _: 1
                }, 8, ["content"]), _createVNode(_component_el_tooltip, {
                  content: _ctx.$t('notifications.markAllAsRead'),
                  class: "box-item",
                  effect: "light",
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("i", {
                    class: "ri-checkbox-circle-line fs-18 gradient-text align-top",
                    onClick: handleReadMessages
                  })]),
                  _: 1
                }, 8, ["content"])])) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_b_row, {
              "no-gutters": ""
            }, {
              default: _withCtx(() => [_unref(isNotifyLoading) ? (_openBlock(), _createBlock(_component_b_col, {
                key: 0,
                class: "d-flex justify-content-center align-items-center",
                cols: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_b_spinner, {
                  class: "d-block mx-auto",
                  label: "large Spinning",
                  type: "grow",
                  variant: "info"
                })])]),
                _: 1
              })) : !_unref(notificationList)?.data?.length ? (_openBlock(), _createBlock(_component_b_col, {
                key: 1
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('notifications.noNotificationFound')), 1)])]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_b_col, {
                key: 2,
                cols: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("table", _hoisted_14, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationList)?.data, notify => {
                  return _openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass({
                      'gradient-border-color  table-active': !notify.is_read
                    }),
                    style: {
                      "cursor": "pointer"
                    },
                    onClick: $event => handleRedirection(notify?.data?.path, notify?.id)
                  }, [_createElementVNode("td", null, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [notify.data?.sender?.image ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: notify.data?.sender?.fullname,
                    src: notify.data?.sender?.image,
                    class: "avatar-xs rounded-circle"
                  }, null, 8, _hoisted_18)) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(notify.data?.sender?.fullname?.charAt(0) || '-'), 1)]))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("h5", _hoisted_22, _toDisplayString(notify.data.message), 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, _toDisplayString(notify?.created_at), 1), _createVNode(_component_b_badge, {
                    class: "bg-secondary-subtle text-secondary"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(customizeText)(notify?.data?.group) || '-'), 1)]),
                    _: 2
                  }, 1024)])])])])], 10, _hoisted_15);
                }), 256))])])]),
                _: 1
              })), _unref(notificationList)?.data?.length ? (_openBlock(), _createBlock(_component_b_col, {
                key: 3,
                class: "text-center mb-2",
                cols: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: "gradient-text",
                  type: "text",
                  onClick: goToNotificationPage
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('notifications.viewAllNotifications')) + " ", 1), _hoisted_25]),
                  _: 1
                })]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              disabled: _unref(route)?.path === '/profile/notifications',
              class: "notifyBtn",
              round: "",
              text: "",
              variant: "ghost-secondary",
              onClick: handleClickNotifications
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                content: _ctx.$t('notifications.unreadNotifications'),
                disabled: !_unref(hasUnreadMsg),
                class: "box-item",
                effect: "light",
                placement: "left"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_badge, {
                  hidden: _unref(notifyUnreadCount) < 1,
                  max: 100,
                  value: _unref(notifyUnreadCount),
                  class: "item"
                }, {
                  default: _withCtx(() => [_hoisted_6]),
                  _: 1
                }, 8, ["hidden", "value"])]),
                _: 1
              }, 8, ["content", "disabled"])]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          }, 512), _createVNode(_component_el_button, {
            class: "notifyBtn m-0 d-none d-md-inline-block",
            round: "",
            text: "",
            variant: "ghost-secondary",
            onClick: toggleDarkMode
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass(!isDarkMood.value ? 'bx bx-moon fs-22' : 'ri-sun-line fs-22')
            }, null, 2)]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "notifyBtn m-0 d-none d-md-inline-block",
            "data-toggle": "fullscreen",
            round: "",
            text: "",
            variant: "ghost-secondary",
            onClick: initFullScreen
          }, {
            default: _withCtx(() => [_hoisted_26]),
            _: 1
          }), _createVNode(_component_el_dropdown, {
            size: "large"
          }, {
            dropdown: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, [_createVNode(_component_el_image, {
              src: getCurrentUser.value.image,
              alt: "Header Avatar",
              class: "header-profile-user avatar-md"
            }, null, 8, ["src"]), _createElementVNode("span", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(getCurrentUser.value.fullname), 1), _createElementVNode("span", _hoisted_32, _toDisplayString(getCurrentUser.value.position), 1)])])]), _createElementVNode("div", null, [_createVNode(_component_el_dropdown_menu, {
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/profile/overview'))
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('common.overview')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/profile/performance'))
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('task.userAnalytics')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: _cache[3] || (_cache[3] = $event => _unref(router).push('/profile/editProfile'))
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('profile.editProfile')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
                  name: 'notifications-settings'
                }))
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('notifications.notificationSetting')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: toggleDarkMode
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("i", {
                  class: _normalizeClass([!isDarkMood.value ? 'bx bx-moon fs-16' : 'ri-sun-line fs-22', "text-muted align-middle me-1 my-1"])
                }, null, 2), _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('header.theme')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                class: "d-lg-none d-sm-inline-block",
                style: {
                  "width": "100%"
                },
                onClick: initFullScreen
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("i", {
                  class: _normalizeClass(['bx bx-fullscreen fs-16', "text-muted align-middle me-1 my-1"])
                }), _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('header.theme')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                style: {
                  "width": "100%"
                },
                onClick: _cache[5] || (_cache[5] = $event => logout())
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('header.logout')), 1)])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                class: "d-lg-none d-sm-inline-block",
                style: {
                  "width": "100%"
                },
                onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
                  name: 'subscription'
                }))
              }, {
                default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_52, [getCurrentUser.value?.delegatee?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  class: "d-block mb-1",
                  type: "warning"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegatee')) + " : " + _toDisplayString(getCurrentUser.value?.delegatee?.fullname?.split(' ')[0]), 1)]),
                  _: 1
                })) : _createCommentVNode("", true), getCurrentUser.value?.delegator?.fullname ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  class: "d-block mb-1",
                  type: "success"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.delegator')) + " : " + _toDisplayString(getCurrentUser.value?.delegator?.fullname?.split(' ')[0]), 1)]),
                  _: 1
                })) : _createCommentVNode("", true), hasPermissions.value('subscription-list-request') ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  type: _unref(subscriptionRemainingDays) > 4 ? 'primary' : 'danger',
                  class: "d-block mb-1"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('header.subscription')) + ": " + _toDisplayString(_unref(subscriptionRemainingDays)) + " " + _toDisplayString(_ctx.$t('header.daysRemaining')), 1)]),
                  _: 1
                }, 8, ["type"])) : _createCommentVNode("", true)])])]),
                _: 1
              })]),
              _: 1
            })])])]),
            default: _withCtx(() => [_createVNode(_component_el_image, {
              src: getCurrentUser.value.image,
              alt: "Header Avatar",
              class: "rounded-circle",
              style: {
                "width": "40px",
                "margin-right": "10px",
                "height": "40px"
              }
            }, null, 8, ["src"])]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};